import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getProductMergeEnabled = unaryRpc({
  name: "getProductMergeEnabled" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean() }),
});

export const updateProductMergeEnabled = unaryRpc({
  name: "updateProductMergeEnabled" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({ enabled: z.boolean() }),
  mock: (_generated, input) => ({ enabled: input.enabled }),
});
